import React, { FC } from 'react';
import ExternalLinkDialog from './components/ExternalLinkDialog';
import useBooleanState from 'src/hooks/useBooleanState';
import { Box, Typography } from '@material-ui/core';
import Button from 'src/components/Button';

interface Props {
  dealId?: number;
  providerId?: string;
}

const ExternalLinkButton: FC<Props> = ({ dealId, providerId }) => {
  const [isOpen, , open, close] = useBooleanState(false);

  return (
    <>
      <Box mb={1}>
        <Typography variant='caption' component='div'>
          Pour permettre au prestataire de completer le bon de livraison, vous pouvez lui générer un lien externe.
        </Typography>
      </Box>

      <Button variant='outlined' color='primary' onClick={open}>
        Générer un lien externe
      </Button>

      <ExternalLinkDialog onClose={close} open={isOpen} dealId={dealId} providerId={providerId} />
    </>
  );
};

export default ExternalLinkButton;
